import React from 'react';
import { SearchEmptySuggestionsList } from '../SearchEmptySuggestionsList';
import { SearchSuggestionItem } from '../SearchSuggestionItem';
import { SearchSuggestionListGroup } from './style';
export var SearchSuggestionsList = function SearchSuggestionsList(_ref) {
  var options = _ref.options,
      groupIndex = _ref.groupIndex,
      handleSuggestionClick = _ref.handleSuggestionClick,
      additionalInfo = _ref.additionalInfo,
      renderItemAdditionalInfo = _ref.renderItemAdditionalInfo,
      icon = _ref.icon,
      renderItemIcon = _ref.renderItemIcon,
      cursor = _ref.cursor,
      searchQuery = _ref.searchQuery,
      noResultsLabel = _ref.noResultsLabel,
      theme = _ref.theme,
      groupClassName = _ref.groupClassName;

  if (options && options.length) {
    var displayedGroups = {};
    return options.map(function (option, index) {
      var label = option.label,
          groupId = option.groupId;
      var group = null;

      if (groupIndex && groupId && groupId in groupIndex && !displayedGroups[groupId]) {
        group = groupIndex[groupId];
        displayedGroups[groupId] = true;
      }

      return React.createElement(React.Fragment, null, !!group && React.createElement(SearchSuggestionListGroup, {
        className: groupClassName,
        theme: theme,
        enableSeparator: index > 0
      }, group.label), React.createElement(SearchSuggestionItem, {
        key: label,
        option: option,
        optionIndex: index,
        suggestionIndex: index,
        handleSuggestionClick: handleSuggestionClick,
        additionalInfo: additionalInfo,
        renderItemAdditionalInfo: renderItemAdditionalInfo,
        icon: icon,
        renderItemIcon: renderItemIcon,
        cursor: cursor,
        searchQuery: searchQuery,
        theme: theme
      }));
    });
  }

  return React.createElement(SearchEmptySuggestionsList, {
    theme: theme,
    noResultsLabel: noResultsLabel
  });
};